import qiniuStroage from './qiniu';
import upyunStroage from './upyun';
import Cookies from 'js-cookie';
import {
    scratchJsonFileStorageHost,
    scratchFileStorageUpYunHost
} from './service';

/*
*@param {blob} homeworkFile 作业内容
*@param {name} name 作业名称
*@param {function} progressObserver 占位
*@return {Promise}
*/

const saveProjectData = function (homeworkFile, count, upLoadLine, progressObserver){
    return new Promise((resolve, reject) => {

        const userId = Number(Cookies.get('userId'));
        if (!userId) {
            return;
        }
        const date = new Date();
        const timestamp = date.getTime();
        const randomNum = parseInt(Math.random() * 1000, 10);
        const homeworkName = `${userId}-${timestamp}-${count}-${randomNum}.zip`;
        let homeworkUrl = `${scratchJsonFileStorageHost}`;
    
        const callbackOnUploadCompleted = function (fileName) {
            const url = `//${homeworkUrl}/${fileName}`;
            if (resolve){
                resolve(url);
            } else {
                reject(new Error(/* Error */));
            }
        };
        switch (upLoadLine) {
        case 'qiniu':
            homeworkUrl = `${scratchJsonFileStorageHost}`;
            qiniuStroage(homeworkName, homeworkFile, progressObserver, callbackOnUploadCompleted, reject, 'sbdata');
            break;
        case 'upyun':
            homeworkUrl = `${scratchFileStorageUpYunHost}`;
            upyunStroage(homeworkName, homeworkFile, callbackOnUploadCompleted, reject);
            break;
        default:
            
        }
    });
};
export {
    saveProjectData
};
